/** Get Dashboard Chart data */
export const DYNAMIC_API_SUCCESS = "DYNAMIC_API_SUCCESS"
export const DYNAMIC_API_FAIL = "DYNAMIC_API_FAIL"

export const GET_DYNAMIC_SIDEBAR = "GET_DYNAMIC_SIDEBAR"
export const GET_DYNAMIC_LIST = "GET_DYNAMIC_LIST"
export const GET_DYNAMIC_PROFILE_TAB_DATA = "GET_DYNAMIC_PROFILE_TAB_DATA"

export const UPDATE_DYNAMIC_LOADING_STATE = "UPDATE_DYNAMIC_LOADING_STATE"
